import Lottie from 'lottie-react';
import { css } from '@emotion/react';
import { Badge } from '@uniquegood/realworld-studio-design';
import { onMobile } from '@/styles/responsive';
import aiSparkleAnimation from '@/assets/lottie/AI-Sparkle.json';
import { badgeProps } from '@/utils';

interface AiLoadingThumbnailProps {
  title?: string;
}

const AiGeneratingIcon = () => (
  <div css={AiIconContainer}>
    <div css={LottieGradientWrapper}>
      <Lottie
        animationData={aiSparkleAnimation}
        loop
        autoplay
        style={{
          width: '100%',
          height: '100%'
        }}
        rendererSettings={{
          preserveAspectRatio: 'xMidYMid meet',
          progressiveLoad: false,
          hideOnTransparent: true
        }}
      />
    </div>
  </div>
);

function AiLoadingThumbnail({ title }: AiLoadingThumbnailProps) {
  return (
    <div css={ThumbnailContainer}>
      <div css={BadgeContainer}>
        <div css={BadgeWrapper}>
          <Badge
            cssStyle={css`
              z-index: 1;
              position: relative;
            `}
            {...badgeProps.Creating}
          />
        </div>
      </div>
      <div css={CenterContent}>
        <AiGeneratingIcon />
        <div css={TextContainer}>
          <div css={Title}>{title}</div>
          <div css={GeneratingText}>새로고침으로 상태를 확인해주세요</div>
        </div>
      </div>
    </div>
  );
}

export default AiLoadingThumbnail;

const ThumbnailContainer = css`
  position: relative;
  width: 100%;
  height: 100%;
  aspect-ratio: 310 / 330;
  background-color: #f2f9ff;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  overflow: hidden;
  border-radius: 16px;
  border: 1px solid var(--border-Default-Subdued, #ededed);
  box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.07);

  ${onMobile} {
    border-radius: 16px;
    height: 140px;
    box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.07);
    border: 1px solid #ededed;
  }
`;

const CenterContent = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 257px;
  gap: 8px;

  ${onMobile} {
    width: 100%;
    gap: 8px;
    flex: 1;
    min-width: 0;
    min-height: 0;
  }
`;

const TextContainer = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  text-align: center;
  gap: 4px;

  ${onMobile} {
    align-items: center;
    justify-content: center;
    gap: 0;
  }
`;

const AiIconContainer = css`
  width: 40px;
  height: 40px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  ${onMobile} {
    width: 32px;
    height: 32px;
    margin: 0 !important;
  }
`;

const LottieGradientWrapper = css`
  width: 100%;
  height: 100%;
`;

const GeneratingText = css`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  align-self: stretch;
  overflow: hidden;
  text-align: center;
  font-feature-settings: 'liga' off, 'clig' off;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  flex-shrink: 0;
  font-family: 'Pretendard', sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  background: linear-gradient(94deg, #4a41ff 0%, #22f8e2 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  ${onMobile} {
    font-size: 12px;
    line-height: 16px;
  }
`;

const Title = css`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  align-self: stretch;
  overflow: hidden;
  color: var(--text-Default, #191919);
  text-align: center;
  font-feature-settings: 'liga' off, 'clig' off;
  text-overflow: ellipsis;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;

  ${onMobile} {
    font-size: 16px;
    line-height: 24px;
    margin: 0 !important;
  }
`;

const BadgeContainer = css`
  position: absolute;
  top: 16px;
  left: 15.67px;
  z-index: 1;

  ${onMobile} {
    left: 24px;
  }
`;

const BadgeWrapper = css`
  display: inline-block;
  border-radius: 100px;

  ${onMobile} {
    box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.12);
    border-radius: 100px;
  }
`;
